<mat-menu #childMenu="matMenu">
  <!-- [overlapTrigger]="false" ] -->
  <ng-container *ngFor="let menu of items">
    <ng-container *ngIf="!menu.hideInMenu && (rolesOk(menu.needsRole) | async)">
      <ng-container *ngIf="menu.subMenu as mySubMenu;else noSubMenu">
        <app-nav-bar-menu-item #subMenuItem [items]="mySubMenu" [basePath]="fullPath(menu.path)">
        </app-nav-bar-menu-item>
        <a mat-menu-item [routerLink]="fullPath(menu.path)"
          [matMenuTriggerFor]="subMenuItem.childMenu">{{menu.description}}
        </a>
      </ng-container>
      <ng-template #noSubMenu>
        <a mat-menu-item [routerLink]="fullPath(menu.path)">{{menu.description}}</a>
      </ng-template>
    </ng-container>
  </ng-container>
</mat-menu>
